export const theme = {
  mainColor: "#85a303",
  secondaryColor: "#d6f00e",
  transparent: "rgba(0,0,0,0.7)",
}
